const axios = require('axios');
const { AVAILABLE_METRICS } = require('../utils/datadog/metrics');

const createMetricSender = () => {
  const serviceUrl = '/generic-landings/api/metrics';
  function sendEventForCustomerMetric(event) {
    axios
      .post(serviceUrl, {
        event,
      })
      .catch((e) => console.error('Error sending metric', e));
  }

  return {
    onLoadedEmptyFilter: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_EMPTY_FILTER),
    onBtFilterClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.BT_FILTER_CLICK),
    onItemClick: () => sendEventForCustomerMetric(AVAILABLE_METRICS.ITEM_CLICK),
    onItemTop10PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.ITEM_TOP_POSITION_CLICK),
    onItemTop25PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.ITEM_SECOND_RANGE_CLICK),
    onItemTop50PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.ITEM_THIRD_RANGE_CLICK),
    onItemHigh50PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.ITEM_FOURTH_RANGE_CLICK),
    onVendorTop25PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_SECOND_RANGE_CLICK),
    onVendorTop50PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_THIRD_RANGE_CLICK),
    onVendorHigh50PositionClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_FOURTH_RANGE_CLICK),
    onDeliveryTimeFilterClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.DELIVERY_TIME_FILTER_CLICK),
    onDistanceFilterClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.DISTANCE_FILTER_CLICK),
    onRankingFilterClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.RANKING_FILTER_CLICK),
    onTermsAndConditionsClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.TERMS_AND_CONDITIONS_CLICK),
    onBackButtonClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.BACK_BUTTON_CLICK),
    onVendorPositionTopClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_TOP_POSITION_CLICK),
    onVendorClick: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.VENDOR_CLICK),
    onLoadedEmptyState: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_EMPTY_STATE),
    sendServerError: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.SERVER_ERROR),
    sendClientError: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.CLIENT_ERROR),
    onLoadedEmptyItem: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_EMPTY_ITEM),
    onLoadedErrorItem: () =>
      sendEventForCustomerMetric(AVAILABLE_METRICS.LOADED_ERROR_ITEM),
  };
};

module.exports = { createMetricSender };
